<template>
	<ul class="nav nav-pills sub-tabs">
		<li v-for="tab in tabs" :key="tab.to" class="nav-item">
			<RouterLink :to="tab.to" class="nav-link">
				<i class="bi" :class="tab.icon"></i> {{ tab.label }}
			</RouterLink>
		</li>
	</ul>
</template>

<script setup lang="ts">
import { RouterLink } from "vue-router";

// One section tab: the surface's path, its label, and the Bootstrap icon glyph.
interface SectionTab {
	to: string;
	label: string;
	icon: string;
}

defineProps<{
	tabs: SectionTab[];
}>();
</script>

<style scoped>
.sub-tabs .nav-link {
	font-size: 0.9rem;
	padding: 0.4rem 1rem;
}
.sub-tabs .nav-link.router-link-exact-active {
	background-color: #198754;
	color: #fff;
}
.sub-tabs .nav-link:not(.router-link-exact-active) {
	color: #6c757d;
}
</style>
